import {
  CLEAR_PROFESSIONAL,
  SELECT_PROFESSIONAL,
} from '../actions/ActionTypes';

const initialState = null;

export default function selectedServices(state = initialState, action) {
  switch (action.type) {
    case SELECT_PROFESSIONAL:
      return action.payload;
    case CLEAR_PROFESSIONAL:
      return initialState;
    default:
      return state;
  }
}
